// extracted by css-extract-rspack-plugin
export default {"list":"Cp1rVMFeAdevkQ_E","item":"skoG0cIkBywVz_xL"};